import { fetchDevelopmentPage } from "../services/contentApi";
import { ServicePageProvider, useServicePage, useServiceSection } from "./ServicePageContext";

export function DevelopmentPageProvider({ children }) {
  return (
    <ServicePageProvider fetchPage={fetchDevelopmentPage}>
      {children}
    </ServicePageProvider>
  );
}

export const useDevelopmentPage = useServicePage;
export const useDevelopmentSection = useServiceSection;
